export const SOURCE_ID_PLACEHOLDER = 'sourceId TBD upon delivery';
